$('.facebook-share, .twitter-share').click(function () {
  window.open(this.href, '_blank', 'width=700,height=500,toolbar=0,menubar=0,location=0,status=1,scrollbars=1,resizable=1,left=0,top=0');
  return false;
});
